export const Types = {
  SAVE_LIST_TEAM: "SAVE_LIST_TEAM",
  SAVE_DETAIL_TEAM: "SAVE_DETAIL_TEAM"
};
